import XLSX from "xlsx";

import License, { LicenseStatus, SpectralService } from "spectral-core/models/License";

const DataTemplate = (license: License) => {
  let data = [];

  data.push(license.rowKey);
  data.push(license.name);
  data.push(license.description);
  data.push(FormatDate(license.timestamp));
  data.push(LicenseStatus[license.status]);
  data.push(license.price);
  data.push(FormatDate(license.expiresAt));
  data.push(SpectralService[license.service]);
  data.push(FormatStringList(license.users));
  data.push(license.isDeviceRestrict);
  data.push(FormatStringList(license.devices));
  data.push(license.isModelRestrict);
  data.push(FormatStringList(license.models));
  data.push(license.computerMac);
  return data;
}

const FormatStringList = (text: string) => {
  let list = JSON.parse(text) as string[];

  if (list === null)
    return list;

  return list.join(', ');
}

const FormatDate = (date: Date) => {
  return new Date(date)
    .toLocaleString()
    .replace(',', '');
}

const FillDataInExcel = (rows: License[]) => {
  return rows.map((license) => DataTemplate(license));
}

const FillHeader = () => {
  let header = [];

  header.push("Id");
  header.push("Name");
  header.push("Description");
  header.push("CreatedAt");
  header.push("Status");
  header.push("Price");
  header.push("ExpiresAt");
  header.push("Service");
  header.push("Users");
  header.push("IsDeviceRestrict");
  header.push("Devices");
  header.push("IsModelRestrict");
  header.push("Models");
  header.push("ComputerMac");

  return header;
}

export default function BuildLicenseSheet(licenses: License[]) {
  let header = [];
  let wb = XLSX.utils.book_new();

  wb.Props = {
    Title: "Licenças",
    Author: "Spectral Solutions",
    CreatedDate: new Date()
  };

  wb.SheetNames.push("Licenças")
  let filledData = FillDataInExcel(licenses);
  header = FillHeader();

  let wsData = [header];

  filledData.forEach((element) => {
    //@ts-ignore
    wsData.push(element);
  });

  var ws = XLSX.utils.aoa_to_sheet(wsData)
  wb.Sheets["Licenças"] = ws;
  return XLSX.write(wb, { bookType: "xlsx", type: "binary" });
}